import React, { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
// import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import axios from "axios";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as DashSquareFill } from "bootstrap-icons/icons/dash-square-fill.svg";
import { ReactComponent as FilePlusFill } from "bootstrap-icons/icons/file-plus-fill.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import stateandcity from "../../../components/utils/stateandcity.json"


const FundBranchWallets = () => {
    const [wallet_type, setWalletType] = useState("");
    const [amount, setAmount] = useState("");
    const [description, setDescription] = useState("");
    const [branch_id, setBranchId] = useState("");
    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();
    const location = useLocation();
    const { id } = location.state || {};

    useEffect(() => {
        if (id) setBranchId(id);
    }, []);

    // Validation function
    const validateForm = () => {
        if (!amount || !wallet_type || !description) {
            toast.error("All fields are required.");
            return false;
        }
        return true;
    };


    //axios api encryption call
    const axios = AxiosApiCall();

    // handle submit button
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        const formData = {
            branch_id,
            amount,
            wallet_type,
            description,
        };
        // console.log("this is my form data", formData);

        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            const token = authData?.token;
            if (!token) {
                throw new Error("No access token found.");
            }

            const response = await axios.post(
                ApiServices.fundBranchWalletsOpe,
                formData,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    withCredentials: true,
                }
            );

            const { status, message } = response.data;
            if (status === 200) {
                navigate("/operations/branch/list");
                toast.success(message, { toastId: "opeartion-branch-wallets-funded-success" });
                // toast.success(message);
            } else {
                handleError({ response: { status, data: { message } } }, navigate);
            }
        } catch (error) {
            handleError(error, navigate);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <MainLayouts>
                <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                    {/* form here */}
                    <section className=" body-font">
                        <div className="container px-5 pb-2 mx-auto ">
                            <section
                                className="w-full pr-[3%] pt-3 my-3"
                                style={{ backgroundColor: "#F7F7F7" }}
                            >
                                {/* Flex container for breadcrumb and back button */}
                                <div className="flex justify-between items-center bg-gray-200 py-2 px-4 rounded-lg mb-3">
                                    {/* Breadcrumb - Left aligned */}
                                    <nav>
                                        <ol className="list-none p-0 inline-flex">
                                            <li className="flex items-center">
                                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                    Branch Operation
                                                </p>
                                                <ChevronRightIcon />
                                            </li>
                                            <li className="flex items-center">
                                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                                    Wallet
                                                </p>
                                                <ChevronRightIcon />
                                            </li>
                                            <li className="flex items-center">
                                                <p className="text-orange1">Funding</p>
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </section>

                            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                                <form onSubmit={handleSubmit}>
                                    {/* Name and Email */}
                                    <input type="hidden" value={branch_id} />
                                    <div className="flex w-full mb-3 gap-4">
                                        {/* <div className="w-full">
                                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Name
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                placeholder="Enter full name"
                                            />
                                        </div> */}
                                        {/* <div className="w-1/2">
                                            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                placeholder="Enter email address"
                                            />
                                        </div> */}
                                    </div>

                                    {/* Phone Number and State */}
                                    <div className="flex w-full mb-3 gap-4">
                                        <div className="w-1/2">
                                            <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Amount
                                            </label>
                                            <input
                                                type="number"
                                                name="amount"
                                                id="amount"
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                                placeholder="Enter amount"
                                            />
                                        </div>
                                        <div className="w-1/2">
                                            <label htmlFor="wallet_type" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                Wallet Type
                                            </label>
                                            <select
                                                name="wallet_type"
                                                id="wallet_type"
                                                value={wallet_type}
                                                onChange={(e) => {
                                                    setWalletType(e.target.value);
                                                }}
                                                className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                            >
                                                <option value="" disabled>Select Wallet Type</option>
                                                <option value="main">Main</option>
                                                <option value="incentive">Incentive</option>
                                                {/* <option value="expense">Expense</option> */}
                                                <option value="float">Float</option>

                                            </select>
                                        </div>
                                    </div>



                                    {/* Full width text area for longer address */}
                                    <div className="w-full mb-3">
                                        <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                            Description
                                        </label>
                                        <textarea
                                            name="description"
                                            id="description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                                            placeholder="Enter brief description."
                                        />
                                    </div>

                                    {/* Buttons */}
                                    <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">

                                        <Link
                                            to="/operations/branch/list"
                                            className="text-dGrey3 bg-black2 py-4 px-6 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm  text-center"
                                        >
                                            <span className="flex items-center">
                                                <List className="mr-2" />
                                                Back To List
                                            </span>
                                        </Link>
                                        <button
                                            type="submit"
                                            className={`text-dGrey3 bg-darkGreen3 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded font-medium ${loading ? "btn-loading" : "btn-primary"}`}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Fund Wallet"}
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </section>
                </div>
            </MainLayouts>
        </div>
    );
};

export default FundBranchWallets;
